  import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
  Table,
} from "reactstrap";
import { useSafariPaymentReset } from "../../hooks/useSafariPaymentReset";
import CustomInput from "../../custom/CustomInput";
import CustomSelect from "../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CircularIndeterminate from "../loader/CircularIndeterminate";
import { Autocomplete, TextField } from "@mui/material";
import LinerLoader from "../../components/loader/LinearProgress";

const EnrollTrinityOnline = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  // const { courses, isLoading } = useSelector((state) => state.courses);
  const { courseByEvents, isLoading } = useSelector(
    (state) => state.courseByEvents
  );

  // const defaultProps = {
  //   options: courses?.filter((itm) => itm?.event_id == "24"),
  //   getOptionLabel: (option) => option.name,
  // };

  // Initial load or default behavior can be handled here if needed
  // For now, we'll let the exam_type selection drive the data fetching
  // useEffect(() => {
  //   dispatch(actions.courseByEventsGetData(data));
  // }, []);

  const trinityProps = {
    options: courseByEvents,
    getOptionLabel: (option) => option.name,
  };

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const coursereg = {
      clientname: values.clientname,
      parent_name: values.parent_name,
      gender: values.gender,
      dob: values.dob,
      address: values.address,
      city: values.city,
      pincode: values.pincode,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      your_exam: values.your_exam,
      branch_name: values.branch_name,
      your_teacher: values.your_teacher,
      course_id: values.course_id,
      totalfees: values.totalfees,
      aadhar_no: values.aadhar_no,
      pan_no: values.pan_no,
      is_enquiry: values.is_enquiry,
      is_online_payment: values.is_online_payment,
    };
    // iOS Safari compatible redirect
    dispatch(
      actions.postCourseregDataWithBackendRedirect(coursereg, setSubmitting, resetForm)
    );
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for Examination.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  parent_name: "",
                  gender: "",
                  dob: "",
                  address: "",
                  city: "",
                  pincode: "",
                  clientemail: "",
                  clientphone: "",
                  your_exam: "",
                  is_learning_mode: "online",
                  your_teacher: "",
                  branch_name: "Online",
                  course_id: "",
                  totalfees: "",
                  aadhar_no: "",
                  pan_no: "",
                  is_enquiry: "0",
                  is_online_payment: "1",
                  exam_type: "",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                  exam_type: Yup.string().required("required"),
                  your_exam: Yup.string().required("required"),
                  branch_name: Yup.string().required("required"),
                  your_teacher: Yup.string().required("required"),
                  course_id: Yup.string().required("required"),
                })}
              >
                {(formProps) => {
                  const total = formProps.values.totalfees;
                  return (
                    <Form className="mt-3">
                      {console.log("formProps", formProps.values)}
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="clientname" className="label">
                            Your Full Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientname"
                              id="clientname"
                              placeholder="Enter Your Full Name"
                              className={
                                "form-control" +
                                (formProps.errors.clientname &&
                                  formProps.touched.clientname
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientname"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="parent_name" className="label">
                            Your Parent Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="parent_name"
                              id="parent_name"
                              placeholder="Enter Your Parent Name"
                              className={
                                "form-control" +
                                (formProps.errors.parent_name &&
                                  formProps.touched.parent_name
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="parent_name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="gender" className="label">
                            Your Gender:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="gender"
                              id="gender"
                              placeholder="Enter Your Gender"
                              className={
                                "form-control" +
                                (formProps.errors.gender &&
                                  formProps.touched.gender
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select Gender</option>
                              <option value={"Male"}>Male</option>
                              <option value={"Female"}>Female</option>
                            </Field>
                            <ErrorMessage
                              name="gender"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="dob" className="label">
                            Your Date Of Birth :
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="date"
                              name="dob"
                              id="dob"
                              // placeholder="Enter Your Date Of Birth"
                              className={
                                "form-control" +
                                (formProps.errors.dob && formProps.touched.dob
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="dob"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="address" className="label">
                            Your Postal Address:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="textarea"
                              name="address"
                              id="address"
                              placeholder="Enter Your Postal Address:"
                              className={
                                "form-control" +
                                (formProps.errors.address &&
                                  formProps.touched.address
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="address"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="city" className="label">
                            Your City:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="city"
                              id="city"
                              placeholder="Enter Your Residence City"
                              className={
                                "form-control" +
                                (formProps.errors.city && formProps.touched.city
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="city"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="pincode" className="label">
                            Your Pincode:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="pincode"
                              id="pincode"
                              placeholder="Enter Your Pincode"
                              className={
                                "form-control" +
                                (formProps.errors.pincode &&
                                  formProps.touched.pincode
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="pincode"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="clientemail" className="label">
                            Your Email:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientemail"
                              id="clientemail"
                              placeholder="Enter Your Email"
                              className={
                                "form-control" +
                                (formProps.errors.clientemail &&
                                  formProps.touched.clientemail
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientemail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="clientphone" className="label">
                            Your Mobile:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="number"
                              name="clientphone"
                              id="clientphone"
                              placeholder="Enter Your Mobile"
                              className={
                                "form-control" +
                                (formProps.errors.clientphone &&
                                  formProps.touched.clientphone
                                  ? " is-invalid"
                                  : "")
                              }
                              onKeyPress={(e) => {
                                if (
                                  e.key === "e" ||
                                  e.key === "+" ||
                                  e.key === "-"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <ErrorMessage
                              name="clientphone"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-2">
                          <Label htmlFor="aadhar_no" className="label">
                            Your Aadhar Numbar
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="number"
                              name="aadhar_no"
                              id="aadhar_no"
                              placeholder="Enter Your Aadhar Numbar"
                              className={
                                "form-control" +
                                (formProps.errors.aadhar_no &&
                                  formProps.touched.aadhar_no
                                  ? " is-invalid"
                                  : "")
                              }
                              onKeyPress={(e) => {
                                if (
                                  e.key === "e" ||
                                  e.key === "+" ||
                                  e.key === "-"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <ErrorMessage
                              name="aadhar_no"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-2">
                          <Label htmlFor="pan_no" className="label">
                            Your PAN Numbar
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="pan_no"
                              id="pan_no"
                              placeholder="Enter Your PAN Numbar"
                              className={
                                "form-control" +
                                (formProps.errors.pan_no &&
                                  formProps.touched.pan_no
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="pan_no"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="exam_type" className="label">
                            Exam Type:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="exam_type"
                              id="exam_type"
                              className={
                                "form-control" +
                                (formProps.errors.exam_type &&
                                  formProps.touched.exam_type
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={(e) => {
                                const selectedExamType = e.target.value;
                                formProps.setFieldValue("exam_type", selectedExamType);
                                formProps.setFieldValue("your_exam", ""); // Reset your_exam when exam_type changes

                                if (selectedExamType === "Music Grade") {
                                  dispatch(actions.courseByEventsGetData({ id: "68" }));
                                } else if (selectedExamType === "Rock & Pop") {
                                  dispatch(actions.courseByEventsGetData({ id: "69" }));
                                }
                              }}
                            >
                              <option value="">-- Select Exam Type --</option>
                              <option value="Music Grade">Music Grade</option>
                              <option value="Rock & Pop">Rock & Pop</option>
                            </Field>
                            <ErrorMessage
                              name="exam_type"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="your_exam" className="label">
                            Your Exam:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="your_exam"
                              id="your_exam"
                              placeholder="Enter Your Exam"
                              className={
                                "form-control" +
                                (formProps.errors.your_exam &&
                                  formProps.touched.your_exam
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value="">-- Select Your Exam First --</option>
                              {formProps.values.exam_type === "Music Grade" && (
                                <>
                                  <option value={"Music Grade Acoustic Guitar"}>
                                    Music Grade Acoustic Guitar
                                  </option>
                                  <option value={"Music Grade Vocals"}>
                                    Music Grade Vocals
                                  </option>
                                  <option value={"Music Grade Drums"}>
                                    Music Grade Drums
                                  </option>
                                  <option value={"Music Grade Keyboard"}>
                                    Music Grade Keyboard
                                  </option>
                                </>
                              )}
                              {formProps.values.exam_type === "Rock & Pop" && (
                                <>
                                  <option value={"Trinity - Rock & Pop Vocals"}>
                                    Trinity - Rock & Pop Vocals
                                  </option>
                                  <option value={"Electronic Keyboard"}>
                                    Electronic Keyboard
                                  </option>
                                  {/* <option value={"Rock and Pop Guitar"}>
                                    Rock and Pop Guitar
                                  </option> */}
                                  <option value={"Trinity Rock and Pop Keyboard"}>
                                    Trinity Rock and Pop Keyboard
                                  </option>
                                  <option value={"Acoustic Guitar"}>
                                    Acoustic Guitar
                                  </option>
                                  <option value={"Rock n Pop Guitars"}>
                                    Rock & Pop Guitars
                                  </option>
                                  <option value={"Rock n Pop Drums"}>
                                    Rock & Pop Drums
                                  </option>
                                  <option value={"Piano"}>Piano</option>
                                </>
                              )}
                            </Field>
                            <ErrorMessage
                              name="your_exam"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>

                      {formProps.values.your_exam !== "" ? (
                        <>
                          <Row className="form-group">
                            <Col md={6} className="mt-2">
                              <Label htmlFor="your_teacher" className="label">
                                Your Teacher:
                              </Label>
                              <InputGroup>
                                <Field
                                  component={CustomInput}
                                  type="text"
                                  name="your_teacher"
                                  id="your_teacher"
                                  placeholder="Enter Teacher"
                                  className={
                                    "form-control" +
                                    (formProps.errors.your_teacher &&
                                      formProps.touched.your_teacher
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="your_teacher"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          {isLoading ? (
                            <div className="p-3">
                              <LinerLoader />
                            </div>
                          ) : (
                            <Row className="form-group">
                              <Col md={12} className="mt-2">
                                <Label htmlFor="course_id" className="label">
                                  Your Course:
                                </Label>
                                <InputGroup>
                                  <Autocomplete
                                    {...trinityProps}
                                    id="course_id"
                                    name="course_id"
                                    getOptionSelected={(option, value) =>
                                      option.id === value.id
                                    }
                                    onChange={(event, newValue) => {
                                      console.log("new", newValue);
                                      formProps.setFieldValue(
                                        `course_id`,
                                        newValue?.id ?? ""
                                      );
                                      formProps.setFieldValue(
                                        `totalfees`,
                                        newValue?.total_amount ?? ""
                                      );
                                    }}
                                    sx={{ width: "100%" }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Course Name *"
                                        variant="outlined"
                                        name="course_id"
                                        size="small"
                                        className="form-control"
                                        error={
                                          formProps.touched.course_id &&
                                          Boolean(formProps.errors.course_id)
                                        }
                                        helperText={
                                          formProps.touched.course_id &&
                                          formProps.errors.course_id
                                        }
                                      />
                                    )}
                                  />
                                </InputGroup>
                              </Col>
                            </Row>
                          )}
                        </>
                      ) : null}
                      {formProps.values.course_id !== "" ? (
                        <Row className="mt-3">
                          <Col md={10}>
                            <Label className="mt-3 mb-3 text-orange">
                              FEE STRUCTURE:
                            </Label>
                            <Table bordered>
                              <thead>
                                <tr>
                                  <th>Fees Type</th>
                                  <th>Amount [In INR]</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th scope="row">Exam & Prep Fees:</th>
                                  <th scope="row">[{total}]</th>
                                </tr>
                                <tr>
                                  <th scope="row">Sub Total [In INR]:</th>
                                  <th scope="row">{total}</th>
                                </tr>
                                <tr>
                                  <th scope="row">Grand Total:</th>
                                  <th scope="row">
                                    INR <input value={total} readOnly />
                                  </th>
                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      ) : null}

                      <div className="mt-3 mb-3 row">
                        <div className="col-12">
                          <Button
                            type="submit"
                            className="register-btn"
                            size="md"
                            block
                          >
                            {isPostLoading ? (
                              <CircularIndeterminate />
                            ) : (
                              "PAY NOW"
                            )}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default EnrollTrinityOnline;
